// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"483":"06b0de03","756":"f14fb978"}[chunkId] + ".chunk.css";
};